import { Injectable } from "@angular/core";
@Injectable()
export class ModuleConfiguration {
    trafficLigthYellowDays: number;
}